import React, { useEffect, useState } from 'react'
import { X as Close, Check } from 'lucide-react'
import './registr.scss'
import { Link, useNavigate } from 'react-router-dom'
import useGetUserData from '../../../../Utils/useGetUserData'
import { useIntl } from 'react-intl'
import { useGoogleOAuthRegister } from '../../../../hooks/queries'
import { readFirstFactor } from '../../../../lib/twoFactor/firstFactor'
import { useFirstFactorRouter } from '../../../../hooks/useFirstFactorRouter'
export default function RegistrationByGoogle() {
  const [res, setRes] = useState(false)
  const getUserData = useGetUserData()
  const navigate = useNavigate()
  const routeFirstFactor = useFirstFactorRouter()
  const intl = useIntl()
  const googleOAuthRegisterMutation = useGoogleOAuthRegister()

  /**
   * Handles the Google OAuth2 callback after user authentication.
   *
   * This effect runs when the component mounts or when the URL changes.
   * It extracts the 'state' and 'code' parameters from the URL and
   * initiates the Google login process if both parameters are present.
   */
  useEffect(() => {
    const url = new URL(window.location.href)
    // Get the query parameters
    const stateParam = url.searchParams.get('state')
    const codeParam = url.searchParams.get('code')

    if (stateParam && codeParam) {
      googleOAuthRegisterMutation.mutate(
        {
          params: `state=${stateParam}&code=${codeParam}`,
          payload: {
            state: stateParam,
            code: codeParam,
          },
        },
        {
          onSuccess: (data) => {
            // Social login can answer with a second-factor challenge (no cookies).
            routeFirstFactor(readFirstFactor(data), () => {
              setRes(true)
              getUserData()
              setTimeout(() => {
                navigate('/org-dashboard')
              }, 5000)
            })
          },
          onError: () => {
            setRes(false)
          },
        }
      )
    }
  }, [])


  const loading = googleOAuthRegisterMutation.isPending

  return (
    <div className={`${loading && 'skeleton'}`}>
      {loading ? (
        <div className='bg-gray-400 py-10 h-200px text-center card'></div>
      ) : res ? (
        <div className='py-10 text-center card'>
          <Check size={56} className='svg-icon-6x svg-icon-success' />
          <h1 className='text-success'>{intl.formatMessage({ id: 'Login Successful' })}</h1>
          <p>{intl.formatMessage({ id: 'You have successfully signed into your account' })}</p>
        </div>
      ) : (
        <div className='py-10 text-center card'>
          <Close size={56} className='svg-icon-6x svg-icon-danger' />
          <h1 className='text-danger'>{intl.formatMessage({ id: 'Login Failed' })}</h1>
          <p>{intl.formatMessage({ id: 'You have Failed signed into your account' })}</p>
          <Link to={'/auth'}>{intl.formatMessage({ id: 'Try again' })}</Link>
        </div>
      )}
    </div>
  )
}
